<input
    placeholder="Dato"
    class="date-time-picker form-control" [ngClass]="{
'is-invalid': invalid,
'is-valid': valid,
'form-control-sm': inputSmall }">
